import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-copy',
  templateUrl: './copy.component.html'
})
export class CopyComponent {
  @Input() ariaLabel: string = '';
}
